window.lang2 = 
{
  "general": {
    "meta": {
      "tags": "Getaggt \"{{ tags }}\"",
      "page": "Seite {{ page }}"
    },
    "404": {
      "title": "404 Seite nicht gefunden",
      "subtext_html": "The page you requested does not exist.",
      "click_here": "Klicken Sie hier",
      "continue_shopping": " um den Einkauf fortzusetzen."
    },
    "breadcrumbs": {
      "home": "Startseite",
      "cart": "Warenkorb",
      "home_link_title": "Zurück zur Startseite"
    },
    "newsletter_form": {
      "newsletter_email": "ihre-email@beispiel.com",
      "submit": "Abonnieren",
      "newsletter_text": "geben Sie Ihre E-Mail-Adresse"
    },
    "search": {
      "no_results_html": "Ihre Suche nach \"{{ terms }}\" hat keine Ergebnisse hervorgebracht.",
      "results_for_html": "Ihre Suche nach \"{{ terms }}\" hat folgende Ergebnisse hervorgebracht:",
      "title": "Suchen Sie auf unserer Seite nach Produkten",
      "placeholder": "suchen",
      "submit": "Suchen"
    },
    "currency": {
      "change_text": "Währung des Kaufhauses geändert"
    }
  },
  "blogs": {
    "article": {
      "author_on_date_html": "Geposted am {{ date }} von {{ author }}",
      "older_post": "Älterer Post",
      "newer_post": "Neuerer Post",
      "tags": "Tags",
      "comment_meta_html": "{{ author }} am {{ date }}",
      "read_more": "Weiterlesen"
    },
    "comments": {
      "title": "Hinterlassen Sie einen Kommentar",
      "name": "Name",
      "email": "E-Mail",
      "message": "Kommentar",
      "post": "Kommentar posten",
      "moderated": "Bitte beachten Sie, dass Kommentare vor der Veröffentlichung freigegeben werden müssen",
      "success_moderated": "Ihr Kommentar wurde erfolgreich gepostet. Da unser Blog moderiert wird, werden wir ihn erst kurze Zeit später veröffentlichen.",
      "success": "Ihr Kommentar wurde erfolgreich gepostet. Danke!",
      "comments_with_count": {
        "one": "{{ count }} Kommentar",
        "other": "{{ count }} Kommentare"
      },
      "note": "Alle Blog-Kommentare werden vor Veröffentlichung überprüft"
    },
    "sidebar": {
      "recent_articles": "Neueste Artikel",
      "categories": "Kategorien"
    }
  },
  "cart": {
    "general": {
      "title": "Einkaufswagen",
      "remove": "Entfernen",
      "note": "Besondere Hinweise an den Verkäufer",
      "subtotal": "Zwischensumme",
      "shipping_at_checkout": "Liefer- und Preisnachlässe an der Kasse berechnet",
      "update": "Einkaufswagen aktualisieren",
      "checkout": "Zur Kasse",
      "empty": "Ihr Einkaufswagen ist im Moment leer.",
      "continue_browsing_html": "Mit der Suche <a href=\"\/collections\/all\">hier<\/a> fortfahren.",
      "view_cart": "Einkaufswagen ansehen",
      "close_cart": "Einkaufswagen schließen",
      "shopping_cart": "Einkaufswagen",
      "button_checkout": "Zur Kasse gehen",
      "continue_shopping": "Weiter Warenkorb",
      "go_to_cart": "Zum Warenkorb",
      "label": "hinweis",
      "label_text": "Zusätzliche Bemerkungen",
      "shipping_calculator_button": "Berechnen Versandkosten",
      "shipping_calculator_calculating": "Berechnung...",
      "shipping_calculator_error_message": "Fehler: Bitte geben Sie rechts Versandinformationen",
      "shipping_calculator_success_many_rates": {
        "there_are": "Es gibt",
        "shipping_rates_available_for": "Versandkosten für ",
        "starting_at": ", beginnend bei "
      },
      "shipping_calculator_success_one_rate": "Es gibt eine Versandkostenpauschale für die zur Verfügung",
      "shipping_calculator_success_no_rate": "Es gibt keine Versandkostenpauschale zu dieser Bestellung und Ziel zur Verfügung.",
      "shipping_calculator_success_at": "bei"
    },
    "label": {
      "product": "Artikel",
      "price": "Preis",
      "quantity": "Menge",
      "total": "Gesamt",
      "or": "oder"
    },
    "ajax_cart": {
      "continue_shopping": "Weiter Warenkorb",
      "go_to_cart": "Zum Warenkorb",
      "success_text": "Wird in den Warenkorb gelegt.",
      "error": "Fehler",
      "loading": "Wird Geladen",
      "close": "Wird Geladen"
    }
  },
  "collections": {
    "general": {
      "no_matches": "Es tut uns leid, aber Ihre Suche nach Produkten hat keine Treffer ergeben.",
      "link_title": "Durchsuchen Sie unsere {{ title }}-Zusammenstellung",
      "grid_view": "Gitteransicht",
      "list_view": "Listenansicht",
      "show_more": "Zeig mehr",
      "no_more_product": "Keine weitere Produkt-",
      "items_count": {
        "one": "Produkt",
        "other": "Produkte"
      },
      "items_with_count": {
        "one": "{{ count }} Produkt",
        "other": "{{ count }} Produkte"
      },
      "title": "Sammlungen",
      "shop_the_collection": "Unsere Kollektion"
    },
    "sidebar": {
      "types": "Produktart",
      "vendors": "Verkäufer",
      "tags": "Tags",
      "clear": "Klar",
      "clear_all": "alle löschen",
      "refined_by": "Sortiert nach"
    },
    "sorting": {
      "title": "Sortieren nach",
      "featured": "Ausgewählt",
      "best_selling": "Meistverkauft",
      "az": "Alphabetisch, A-Z",
      "za": "Alphabetisch, Z-A",
      "price_ascending": "Preis, niedrig nach hoch",
      "price_descending": "Preis, hoch nach niedrig",
      "date_descending": "Datum, neu nach alt",
      "date_ascending": "Datum, alt nach neu"
    },
    "toolbar": {
      "previous_product": "Vorheriger",
      "next_product": "Nächster",
      "previous": "Vorheriger",
      "next": "Nächster",
      "view_as": "Ansicht als",
      "show": "Show",
      "all": "Alle",
      "showing": "Zeige",
      "of": "von"
    }
  },
  "contact": {
    "form": {
      "name": "Name",
      "email": "E-Mail",
      "phone": "Telefonnummer",
      "message": "Nachricht",
      "placeholder_message": "Bitte hinterlassen Sie Ihren Kommentar hier",
      "send": "Absenden",
      "post_success": "Danke, dass Sie uns kontaktiert haben. Wir werden uns so schnell wie möglich bei Ihnen melden.",
      "submit_contact": "Submit Kontakt"
    }
  },
  "customer": {
    "account": {
      "title": "Mein Account",
      "details": "Account-Details",
      "view_addresses": "Adressen ansehen",
      "return": "Zurück zu Account-Details"
    },
    "activate_account": {
      "title": "Account aktivieren",
      "subtext": "Erstellen Sie ein Passwort, um Ihren Account zu aktiveren.",
      "password": "Passwort",
      "password_confirm": "Passwort bestätigen",
      "submit": "Account aktivieren",
      "cancel": "Einladung ablehnen"
    },
    "addresses": {
      "title": "Ihre Adressen",
      "default": "Standard",
      "add_new": "Neue Adresse hinzufügen",
      "edit_address": "Adresse bearbeiten",
      "first_name": "Vorname",
      "last_name": "Nachname",
      "company": "Firma",
      "address1": "Adresse1",
      "address2": "Adresse2",
      "city": "Stadt",
      "country": "Land",
      "province": "Bundesland",
      "zip": "PLZ",
      "phone": "Telefon",
      "set_default": "Als Standard-Adresse festlegen",
      "add": "Adresse hinzufügen",
      "update": "Adresse aktualisieren",
      "cancel": "Abbrechen",
      "edit": "Bearbeiten",
      "delete": "Löschen",
      "delete_message": "Sind Sie sicher, dass Sie diese Adresse löschen möchten?"
    },
    "login": {
      "title": "Kunden Anmelden",
      "email": "E-Mail",
      "password": "Passwort",
      "forgot_password": "Haben Sie Ihr Passwort vergessen?",
      "sign_in": "Anmelden",
      "cancel": "Zurück zum Shop",
      "guest_title": "Als Gast fortsetzen",
      "guest_continue": "Fortsetzen",
      "login": "Login"
    },
    "orders": {
      "title": "Bestellungen",
      "order_number": "Bestellung",
      "date": "Datum",
      "payment_status": "Zahlungsstatus",
      "fulfillment_status": "Lieferstatus",
      "total": "Gesamt",
      "none": "Sie haben noch keine Bestellungen aufgegeben."
    },
    "order": {
      "title": "Bestellung {{ name }}",
      "date": "Aufgegeben am {{ date }}",
      "cancelled": "Bestellung storniert am {{ date }}",
      "cancelled_reason": "Grund: {{ reason }}",
      "billing_address": "Rechnungsadresse",
      "payment_status": "Zahlungsstatus",
      "shipping_address": "Lieferadresse",
      "fulfillment_status": "Lieferstatus",
      "discount": "Rabatt",
      "shipping": "Versand",
      "tax": "Steuern",
      "product": "Artikel",
      "sku": "SKU",
      "price": "Preis",
      "quantity": "Menge",
      "total": "Gesamt",
      "fulfilled_at": "Geliefert am {{ date }}",
      "subtotal": "Zwischensumme"
    },
    "recover_password": {
      "title": "Passwort zurücksetzen",
      "email": "E-Mail",
      "submit": "Absenden",
      "cancel": "Abbrechen",
      "subtext": "Wir werden Ihnen eine E-Mail zum Zurücksetzen des Passworts schicken.",
      "success": "Wir haben Ihnen eine E-Mail mit einem Link zum Aktualisieren des Passworts geschickt."
    },
    "reset_password": {
      "title": "Account-Passwort zurücksetzen",
      "subtext": "Geben Sie ein neues Passwort für {{ email }} ein",
      "password": "Passwort",
      "password_confirm": "Passwort bestätigen",
      "submit": "Passwort zurücksetzen"
    },
    "register": {
      "title": "Account erstellen",
      "first_name": "Vorname",
      "last_name": "Nachname",
      "email": "E-Mail",
      "password": "Passwort",
      "submit": "Ein Konto erstellen",
      "cancel": "Zurück zum Shop"
    },
    "form": {
      "error_message": "Sorry, sieht aus wie etwas schief gelaufen ist. Bitte korrigieren Sie die folgende wieder einreichen:"
    }
  },
  "home_page": {
    "sections": {
      "frontpage_title": "Startseite-Zusammenstellung",
      "featured_title": "Ausgewählte Zusammenstellungen",
      "news_title": "Neueste Nachrichten"
    },
    "onboarding": {
      "modal_title": "Fast fertig...",
      "no_products_html": "Sie haben keine Artikel in Ihrer Startseiten-Zusammenstellung. Dieser Platzhalter verschwindet, wenn Sie <a href=\"\/admin\/collections?tutorial=Frontpage\">dieser Zusammenstellung einen Artikel hinzufügen<\/a>.",
      "add_product": "Fügen Sie ein Produkt",
      "product_title": "Beispielhafter Produkttitel",
      "no_collections_html": "Sie haben hier keine Zusammenstellungen zum Anzeigen. <a href=\"\/admin\/custom_collections\">Fügen Sie ein paar Zusammenstellungen<\/a> zur Standard-Startseite hinzu.",
      "add_collection": "Fügen Sie eine Sammlung",
      "collection_title": "Beispielhafter Zusammenstellungstitel"
    },
    "show_more": "Zeig mehr",
    "no_more_product": "Keine weitere Produkt-"
  },
  "layout": {
    "cart": {
      "title": "Einkaufswagen",
      "items_count": {
        "one": "Produkt",
        "other": "Produkte"
      }
    },
    "customer": {
      "account": "Account",
      "logged_in_as_html": "Eingeloggt als {{ first_name }}",
      "log_out": "Ausloggen",
      "log_in": "Einloggen",
      "create_account": "Account erstellen"
    },
    "footer": {
      "linklist_title": "Quick Links",
      "social_title": "Bleiben Sie auf dem Laufenden",
      "newsletter_title": "Newsletter",
      "accepted_payments": "Akzeptierte Zahlungen"
    }
  },
  "products": {
    "general": {
      "previous_product_html": "&larr; Vorheriger Artikel",
      "next_product_html": "Nächster Artikel &rarr;",
      "from": "Von"
    },
    "product": {
      "sold_out": "Ausverkauft",
      "on_sale_from_html": "<strong>Im Angebot<\/strong> ab {{ price }}",
      "unavailable": "Nicht verfügbar",
      "compare_at": "Vergleichen bei",
      "quantity": "Menge",
      "add_to_cart": "In den Einkaufswagen legen",
      "select_options": "Wählen Sie Optionen",
      "quick_view": "Schnellansicht",
      "sale": "Verkauf",
      "in_stock": "auf Lager",
      "out_of_stock": "Ausverkauft",
      "many_in_stock": "Viele auf Lager",
      "from": "von "
    }
  },
  "gift_cards": {
    "issued": {
      "title": "Hier ist Ihre {{ value }} Geschenkkarte für {{ shop }}!",
      "subtext": "Hier ist Ihre Geschenkkarte!",
      "disabled": "Deaktiviert",
      "expired": "Abgelaufen am {{ expiry }}",
      "active": "Läuft ab am {{ expiry }}",
      "redeem": "Nutzen Sie an der Kasse diesen Code, um Ihre Geschenkkarte einzulösen",
      "shop_link": "Einkauf beginnen",
      "print": "Drucken"
    }
  },
  "date_formats": {
    "month_day_year": "%B %d, %Y"
  },
  "wishlist": {
    "general": {
      "my_wishlist": "Mein Wunschzettel",
      "product_image": "Product Image",
      "product_name": "Produktname",
      "unit_price": "Stückpreis",
      "share_wishlist": "Teilen Sie Wunschliste per E-Mail",
      "no_login": "Um eine Wunschliste zu erstellen müssen Sie <a href=\"\/account\/login\"> in <\/a> unterzeichnen oder <a href=\"\/account\/register\"> ein Konto <\/a> erstellen",
      "no_login_html": "Um eine Wunschliste zu erstellen müssen Sie <a href=\"\/account\/login\"> loggen <\/a> oder <a href=\"\/account\/register\"> ein Konto <\/a> erstellen.",
      "add_to_wishlist": "Auf den Wunschzettel",
      "added_to_wishlist": "Zur Wunschliste hinzugefügt",
      "note": "Bereits in Ihrer Merkliste Zur Merkliste",
      "subtext": "Um eine Wunschliste zu erstellen müssen Sie",
      "sign_in": "loggen",
      "or": "oder",
      "create_account": "ein Konto"
    },
    "ajax_wishlist": {
      "go_to_wishlist": "Go Wunschliste",
      "success_text": "wird in Ihrer Merkliste."
    }
  }
}